module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/41dfa445485f7a81540bded1568a600f.png";